module.exports = __webpack_public_path__ + "img/tpc-40.e674b802.webp";